import React from "react";

export const MenuContext = React.createContext({
  collapsed: false,
  closeMenu: value => {
  }
});
MenuContext.displayName = 'MenuContext';
